import type { LocatorJson } from "@msb/reader-bridge";
import type { Bookmark } from "./storage.ts";

/** Deux emplacements désignent la même page : même position Readium, sinon même ressource et progression proche. */
export function samePage(a: LocatorJson, b: LocatorJson): boolean {
  const pa = a.locations?.position;
  const pb = b.locations?.position;
  if (typeof pa === "number" && typeof pb === "number") return pa === pb;
  const ga = a.locations?.progression ?? 0;
  const gb = b.locations?.progression ?? 0;
  return a.href === b.href && Math.abs(ga - gb) < 0.01;
}

export function findBookmark(bookmarks: Bookmark[], locator: LocatorJson | undefined): Bookmark | undefined {
  return locator ? bookmarks.find((b) => samePage(b.locator, locator)) : undefined;
}

export function addBookmark(bookmarks: Bookmark[], locator: LocatorJson, now = new Date()): Bookmark[] {
  if (findBookmark(bookmarks, locator)) return bookmarks;
  const id = `${now.getTime().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
  const next = [...bookmarks, { id, locator, createdAt: now.toISOString() }];
  return next.sort((x, y) => (x.locator.locations?.totalProgression ?? 0) - (y.locator.locations?.totalProgression ?? 0));
}

export function removeBookmark(bookmarks: Bookmark[], id: string): Bookmark[] {
  return bookmarks.filter((b) => b.id !== id);
}
